import styled from "styled-components";
import { color } from "../../../../shared/styles";
import { LedgerSection } from "../../components";

export const SourceMaterialSection = styled(LedgerSection)`
    gap: 12px;
    min-height: 0;
`;

export const SourceMaterialHeader = styled.div`
    display: flex;
    align-items: baseline;
    gap: 8px;
    flex-wrap: wrap;
`;

export const SourceMaterialTitle = styled.div`
    color: ${color.secondary.CHARCOAL};
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;
`;

export const SourceMaterialSubtitle = styled.div`
    color: ${color.emphasis.NEUTRAL_N70};
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
`;

export const SourceMaterialEmpty = styled.div`
    padding: 18px;
    border: 1px dashed ${color.secondary.BORDER};
    border-radius: 7px;
    background-color: ${color.emphasis.NEUTRAL_N5};
    color: ${color.emphasis.NEUTRAL_N70};
    font-size: 13px;
    line-height: 18px;
    text-align: center;
`;

export const SourceMaterialWarning = styled.div`
    padding: 10px 12px;
    border-radius: 5px;
    background-color: ${color.status.WARNING_LIGHT};
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    gap: 10px;
    color: ${color.secondary.CHARCOAL};
    font-size: 12px;
    line-height: 18px;

    .icon {
        color: ${color.status.WARNING};
        font-size: 17px;
        font-weight: 800;
        line-height: 18px;
    }

    .title {
        color: #b75c00;
        font-weight: 700;
    }
`;

export const SourceMaterialTableWrapper = styled.div`
    width: 100%;
    overflow-x: auto;
    border: 1px solid ${color.secondary.BORDER};
    border-radius: 7px;
`;

export const SourceMaterialTable = styled.table`
    width: 100%;
    min-width: 760px;
    border-collapse: collapse;
    color: ${color.secondary.CHARCOAL};
    font-size: 13px;
    line-height: 18px;

    th,
    td {
        padding: 10px 12px;
        border-bottom: 1px solid ${color.secondary.BORDER};
        text-align: left;
        vertical-align: middle;
    }

    th {
        background-color: ${color.emphasis.NEUTRAL_N5};
        font-weight: 700;
        white-space: nowrap;
    }

    tbody tr:last-child td {
        border-bottom: 0;
    }

    tbody tr[data-shortage="true"] {
        background-color: ${color.status.WARNING_LIGHT};
    }

    th:nth-child(4),
    td:nth-child(4),
    th:nth-child(5),
    td:nth-child(5),
    th:nth-child(6),
    td:nth-child(6),
    th:nth-child(7),
    td:nth-child(7) {
        text-align: center;
    }
`;

export const StockCell = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    white-space: nowrap;
`;

export const ShortageChip = styled.span`
    padding: 2px 7px;
    border: 1px solid ${color.status.WARNING};
    border-radius: 999px;
    background-color: ${color.emphasis.NEUTRAL_N0};
    color: #b75c00;
    font-size: 11px;
    font-weight: 600;
    line-height: 16px;
`;
